import styled from 'styled-components'
import variables, { colors, device } from 'Styled/variables'

export const CreateCampaignHead = styled.div`
  padding-left: 0;
  padding-top: 0px;
  margin-bottom: 21px;
  font-size: ${variables.fontSize20};
  font-weight: 600;
  line-height: 30px;
  color: ${colors.mainText};
  @media ${device.mobileMin} {
    padding-top: 5px;
  }
`

export const PlatformsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 56px;
`

export const PlatformContainer = styled.div`
  display: flex;
  padding: 22px 24px 35px 24px;
  background-color: ${colors.white};
  border-radius: 4px;
  position: relative;
  flex-direction: column;
  width: 100%;
  @media ${device.mobileMin} {
    padding: 20px 24px 24px 24px;
  }
`

export const TitleBlock = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr;
  grid-gap: 8px;
  margin-bottom: 16px;
  align-items: center;
  font-size: ${variables.fontSize18};
  font-weight: 400;
  line-height: 27px;
  color: ${colors.mainText};
`

export const Text = styled.div`
  margin-bottom: 16px;
  align-items: center;
  font-size: ${variables.fontSize14};
  font-weight: 400;
  line-height: 21px;
  color: ${colors.greyTextWhiteBg};
`

export const CreateCampaignContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #f2f4f7;
`

interface Props {
  isAuth: boolean
}

export const CreateCampaignBlock = styled.div<Props>`
  background-color: #f2f4f7;
  padding: 0 40px;
  width: 100%;
  padding-top: ${(props: Props) => (props.isAuth ? '0px' : '45px')};

  @media (max-width: 576px) {
    padding: ${(props: Props) => (props.isAuth ? '0px' : '21px 16px')};
    margin: 0;
  }

  @media (min-width: 1080px) {
    width: auto;
  }
`

export const CreateCampaignBody = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 16px;
  width: 100%;
  position: relative;

  @media (min-width: 1080px) {
    width: 800px;
    margin-bottom: 0;
  }
`

export const TextBlock = styled.div`
  height: 48px;
  padding-left: 66px;
  @media (max-width: 576px) {
    padding-left: 0;
  }
`

export const BtnReviewBlock = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`
